import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=069f7be0&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=069f7be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069f7be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069f7be0')) {
      api.createRecord('069f7be0', component.options)
    } else {
      api.reload('069f7be0', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=069f7be0&scoped=true&", function () {
      api.rerender('069f7be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/Home.vue"
export default component.exports